import React from 'react';
import { McpProxyFormData } from '../types';

interface OverviewTabProps {
  formData: McpProxyFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  isEditMode: boolean;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({
  formData,
  handleChange,
  isEditMode,
}) => {
  return (

    <>

      {/* Proxy Route Info */}
      <div className="alert alert-success mb-3" style={{ fontSize: '14px' }}>
        <i className="fas fa-info-circle mr-2"></i><strong>Proxy Route:</strong> {window.location.origin}{formData.channel_prefix || '(select prefix)'}{formData.endpoint_path || '/(enter path)'}
        <button
          type="button"
          className="btn btn-xs ml-2"
          style={{ padding: '2px 6px', fontSize: '11px', outline: 'none' }}
          onClick={(e) => {
            navigator.clipboard.writeText(`${window.location.origin}${formData.channel_prefix || '(select prefix)'}${formData.endpoint_path || '/(enter path)'}`);
            const btn = e.currentTarget as HTMLButtonElement;
            const originalHtml = btn.innerHTML;
            btn.innerHTML = '<i class="fas fa-check"></i>';
            setTimeout(() => { btn.innerHTML = originalHtml; }, 2000);
          }}
          title="Copy to clipboard"
        >
          <i className="fas fa-copy"></i>
        </button>
      </div>

      {/* Target Endpoint Info */}
      <div className="alert alert-info mb-3" style={{ fontSize: '14px' }}>
        <i className="fas fa-route mr-2"></i><strong>Target Endpoint:</strong> {formData.base_url || '(not configured)'}
        <button
          type="button"
          className="btn btn-xs ml-2"
          style={{ padding: '2px 6px', fontSize: '11px', outline: 'none' }}
          onClick={(e) => {
            if (formData.base_url) {
              navigator.clipboard.writeText(formData.base_url);
              const btn = e.currentTarget as HTMLButtonElement;
              const originalHtml = btn.innerHTML;
              btn.innerHTML = '<i class="fas fa-check"></i>';
              setTimeout(() => { btn.innerHTML = originalHtml; }, 2000);
            }
          }}
          title="Copy to clipboard"
          disabled={!formData.base_url}
        >
          <i className="fas fa-copy"></i>
        </button>
      </div>


      <div className="form-group">
        <label htmlFor="name">
          Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="e.g., My API Proxy"
        />
      </div>

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <input
          className="form-control"
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="A brief description of this MCP Proxy"          
        />
      </div>

      {isEditMode && (
        <div className="mb-4">
          <div className="form-check">
            <input 
              type="checkbox" 
              className="form-check-input" 
              id="enabled"
              name="enabled"
              checked={formData.status === 'active'}
              onChange={handleChange}            />
            <label className="form-check-label" htmlFor="enabled">
              <strong>MCP Proxy Enabled</strong> - When unchecked, this MCP Proxy will be stopped and not loaded at startup
            </label>
          </div>
        </div>


      )}
    </>
  );
};

export default OverviewTab;
